import React, { FC, ReactNode, useContext } from "react";
import { Box, Breadcrumb, BreadcrumbData, Flex, Text, ThemeProvider } from "@familyzone/component-library";
import { ReactRouterCompatContext } from "../ContextProvider";
import { InjectedRouter } from "react-router";
import PageTitle from "../title/PageTitle";
import rebrandedTheme from "../../theme/";

export interface PageWithHeaderProps {
  title?: string | ReactNode;
  tools?: JSX.Element;
  breadcrumbs?: BreadcrumbData[];
  children?: ReactNode;
}

const PageWithHeader: FC<PageWithHeaderProps> = ({ breadcrumbs, children = <></>, title, tools }) => {
  const { router } = useContext(ReactRouterCompatContext) as { router: InjectedRouter };

  const handlePush = (e: React.MouseEvent, url: string) => {
    e.preventDefault();
    e.stopPropagation();
    router.push(url);
  };

  return (
    <ThemeProvider theme={rebrandedTheme}>
      {typeof title === "string" && <PageTitle title={title} />}
      <Flex direction="column" flex="1">
        {(breadcrumbs || title) && (
          <Box py="sp16" px="sp24">
            {breadcrumbs && (
              <Flex direction="row">
                <Breadcrumb breadcrumbData={breadcrumbs} push={handlePush} />
              </Flex>
            )}
            {typeof title === "string" ? (
              <Flex direction="row" alignItems="center">
                <Text aria-level={1} fontFamily="heading" fontSize="xxl" color="text.title" mb="xl" pb="md" role="heading" flexGrow={1}>
                  {title}
                </Text>
                {tools ?? ""}
              </Flex>
            ) : (
              title
            )}
          </Box>
        )}
        {children}
      </Flex>
    </ThemeProvider>
  );
};

export default PageWithHeader;
